import styled, { css } from 'styled-components';

interface MenuProps {
  isMenuOpen: boolean;
}

interface BtProps {
  active: boolean;
}

export const Container = styled.div<MenuProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  min-width: 10.5vw;

  padding: 0;
  margin: 0;
  position: relative;
  padding: 2rem;
  background-color: ${({ theme }) => theme.black};
  cursor: pointer;

  ${({ isMenuOpen }) =>
    isMenuOpen
      ? css`
          width: 30vw;
          margin-right: calc(-30vw + 10.5vw);
        `
      : css`
          width: auto;
        `}

  > svg {
    color: ${({ theme }) => theme.white};
    min-height: 3.15vh;
    width: auto;
    position: absolute;
    left: 3.75vw;
  }

  h1 {
    text-align: center;
    text-transform: uppercase;
    font-size: 1rem;
    letter-spacing: 3px;
    font-weight: bold;
    color: ${({ theme }) => theme.text};
    margin-bottom: 0;
  }

  .menu {
    position: absolute;
    display: flex;
    flex-direction: column;
    z-index: var(--zindex-menu);
    min-width: 30vw;

    top: 100%;
    left: 0;
    background-color: ${({ theme }) => theme.menuBackground};
    width: max-content;
    padding: 0rem 0 1rem;

    transform-origin: top;
    transition: 0.3s ease-in;

    p {
      letter-spacing: 1px;
    }

    ${({ isMenuOpen }) =>
      isMenuOpen
        ? css`
            transform: rotateX(0deg);
          `
        : css`
            transform: rotateX(-90deg);
          `}

    .disabled-link {
      opacity: 0.7;
      background-color: ${({ theme }) => theme.menuActive};

      button {
        cursor: not-allowed;
        :hover {
          background: ${({ theme }) => theme.menuActive};
        }
      }
    }
  }
`;

export const Button = styled.button<BtProps>`
  display: flex;
  flex-direction: row;
  border: 0;
  padding: 0;
  margin: 0;
  border-left: 8px solid transparent;
  background: transparent;
  width: 100%;

  :hover {
    background: ${({ theme }) => theme.menuHover};
  }

  ${({ active }) =>
    active &&
    css`
      border-left: 8px solid ${({ theme }) => theme.purple};
      background: ${({ theme }) => theme.menuActive};
    `}

  p {
    text-align: left;
    text-transform: uppercase;
    font-size: 1rem;
    color: ${({ theme }) => theme.text};
    margin: 0;
    padding: 3px 15px;
  }
`;

export const Divider = styled.hr`
  height: 5px;
  margin: 1rem 0;
  background: ${({ theme }) => theme.menuActive};
`;
